import Contextmenu from "./src/index.js"

export default Contextmenu